import React from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

export default function VisualImageElement({ element, onActions }) {
  const {
    imageUrl = "",
    caption = "",
    captionAlign = "left",
    imageActions = [],
    buttons = [],
  } = element;

  const hasImageAction = imageActions.length > 0;

  const handleImageClick = () => {
    if (hasImageAction) onActions(imageActions);
  };

  return (
    <div className="sce-visualimage">
      {imageUrl ? (
        <div
          className={`sce-visualimage__img-wrap${hasImageAction ? " sce-visualimage__img-wrap--clickable" : ""}`}
          onClick={handleImageClick}
          role={hasImageAction ? "button" : undefined}
          tabIndex={hasImageAction ? 0 : undefined}
          onKeyDown={hasImageAction ? (e) => e.key === "Enter" && handleImageClick() : undefined}
        >
          <img src={imageUrl} alt={caption || ""} className="sce-visualimage__img" />
          {hasImageAction && (
            <div className="sce-visualimage__img-overlay">
              <span className="material-icons">touch_app</span>
            </div>
          )}
        </div>
      ) : (
        <div className="sce-visualimage__placeholder">
          <span className="material-icons" style={{ fontSize: 40, color: "#64748b" }}>
            image
          </span>
          <span style={{ fontSize: 13, color: "#64748b", marginTop: 8 }}>
            {i18n.t("InteractiveScenario.Placeholder.AddImageHint") || "Görsel ekleyin"}
          </span>
        </div>
      )}

      {caption && (
        <p className="sce-visualimage__caption" style={{ textAlign: captionAlign }}>
          {caption}
        </p>
      )}

      {buttons.length > 0 && (
        <div className="sce-visualimage__buttons">
          {buttons.map((btn) => (
            <button
              key={btn.id}
              type="button"
              className={`sce-btn sce-btn--${btn.style || "primary"}`}
              onClick={() => onActions(btn.actions || [])}
            >
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
